import React from "react";
import configMenuList from "../../config-navigation-itens";
import "./configuracoes.css";

export default class MenuConfiguracoes extends React.Component {
  constructor() {
    super();
    this.handleItemClick = this.handleItemClick.bind(this);
    this.compare = this.compare.bind(this);
    this.configMenuListSorted = configMenuList.items.sort(this.compare);
  }

  handleItemClick(path) {
    this.props.history.push(path);
  }

  compare(a,b) {
    if (a.text < b.text)
       return -1;
    if (a.text > b.text)
      return 1;
    return 0;
  }

  render() {
    console.log(configMenuList);
    return (
      <div className={"content-block dx-card responsive-paddings"}>
        <h3>Configurações</h3>
        <div className="config-links-div">
          {this.configMenuListSorted.map((item, index) => {
            if (item.visible || item.visible === undefined) {
              return (
                <div
                  key={index}
                  className="config-links"
                  onClick={() => this.handleItemClick(item.path)}
                >
                  {item.text}
                </div>
              );
            }
          })}
        </div>
      </div>
    );
  }
}
